export default __webpack_public_path__ + "static/sound-on-ee05377134029220c07e129ac4750fff.gif";